import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})

// interface balance{
//   totalBalance: string
// }


export class RitwikiService extends ApiService {

  //Fetch-ritwiki-balance
  public fetchRitwikiBalanceAPI(): Observable<any> {
    return this.get<any>(ROUTES.FETCH_RITWIKI_BALANCE);
  }

  //Fetch-ritwiki-previous requests
  public fetchRitwikiPrevReqsAPI(querryParams: any): Observable<any> {
    return this.get<any>(ROUTES.FETCH_RITWIKI_PREVIOUS_REQS, {
      params: querryParams
    });
  }

  //Fetch-ritwiki-recent-activities
  public fetchRitwikiRecentActvtyAPI(querryParams: any): Observable<any> {
    return this.get<any>(ROUTES.FETCH_RITWIKI_RECENT_ACTIVITY, {
      params: querryParams
    });
  }

  //Ritwiki_withdraw_api
  public ritwikiWithdrawAPI(payload: any): Observable<any> {
    return this.post(ROUTES.RITWIKI_WITHDRAW, { body: payload });
  }

  public ifscDetails(params: any): Observable<any>{
    return this.get<any>(ROUTES.ADD_ACCOUNT, {
      params: params
    })
  }

  public addBankdetails(payload: any): Observable<any>{
    return this.post(ROUTES.ADD_ACCOUNT, {
      body: payload
    })
  }

}
